module.exports = __webpack_public_path__ + "static/img/expert.62d1c1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile/expert.jpg
// module id = V8Rg
// module chunks = 1